import { useIntl } from 'react-intl';
import { Col, Form, FormInstance, Row, Select } from 'antd';

import { useManufacturers } from '@/core/domain/operational/Manufacturers/Manufacturers.hooks';

import { flatInfiniteData } from '@/utils/request/flatInfiniteData';

import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { InputDecimal } from '@/components/_common';
import { QuotationItem } from '@/core/domain/stock/Quotations/Quotations.types';
import { useListRequestPurchases } from '@/core/domain/workorder/RequestPurchase/RequestPurchase.hooks';
import { RequestPurchaseType } from '@/core/domain/workorder/RequestPurchase/RequestPurchase.types';
import formatterPrice from '@/utils/number/formatterPrice';

export interface QuotationItemFormData {
  manufacturerId: number;
  quantity: number;
}

interface QuotationItemFormProps {
  form: FormInstance<QuotationItemFormData>;
  quotationItem?: QuotationItem;
}

const QuotationItemForm = ({ form, quotationItem }: QuotationItemFormProps) => {
  const intl = useIntl();

  const { data: manufacturersData, isFetching: manufacturersIsLoading } =
    useManufacturers({ rows: 9999 });

  const manufacturers = flatInfiniteData(manufacturersData);

  const { data, isLoading } = useListRequestPurchases(
    {
      type: quotationItem?.type as unknown as RequestPurchaseType,
      workOrderFilter: Number(
        quotationItem?.workOrderNumber.split('/')[0],
      ).toString(),
    },
    !!quotationItem?.workOrderNumber,
  );

  const purchases = flatInfiniteData(data);

  const part = purchases.find((item) => item.item.id === quotationItem?.partId);

  return (
    <Form form={form} style={{ marginTop: '16px' }}>
      <Row gutter={16}>
        <Col span={16}>
          <FloatingFormItem
            name={['manufacturerId']}
            label={intl.formatMessage({
              id: 'quotations.details.items.manufacturer',
            })}
          >
            <Select loading={manufacturersIsLoading} style={{ width: '100%' }}>
              {manufacturers.map((m) => (
                <Select.Option key={m.id} value={m.id}>
                  {m.name}
                </Select.Option>
              ))}
            </Select>
          </FloatingFormItem>
        </Col>
        <Col span={8}>
          <FloatingFormItem
            name={['quantity']}
            label={intl.formatMessage({
              id: 'quotations.details.items.quantity',
            })}
            rules={[
              {
                type: 'number',
                min: 0.01,
                max: quotationItem?.workItemId ? part?.total : undefined,
                message: quotationItem?.workItemId
                  ? `O valor deve ser menor ou igual a ${
                      part?.total ? formatterPrice(part?.total) : 0
                    }`
                  : 'Maior que 0',
                required: true,
              },
            ]}
          >
            <InputDecimal disabled={isLoading} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default QuotationItemForm;
